<!-- Popover close button -->
<button data-test="closeButton" type="button" class="popover__close" (click)="closePopover()">
  <i data-test="closeIcon" class="gpr-close"></i>
</button>

<main class="popover-container">
  <section class="d-flex">
    <!-- Popover Title -->
    <div data-test="popoverTitle" class="flex-grow-1 title">{{(editMode ? 'COMPONENTS.ADD_COMMENT' :
      'COMPONENTS.COMMENT') | translate}}</div>

    <!-- Popover action buttons -->
    <div class="" *ngIf="!editMode;">
      <!-- Edit button -->
      <button id="editButton" appStopPropagation (click)="editMode = true" mat-icon-button>
        <i class="gpr-edit icon-font-size"></i>
      </button>

      <!-- Delete button -->
      <button id="deleteButton" (click)="deleteComment()" mat-icon-button>
        <i class="gpr-delete icon-font-size"></i>
      </button>
    </div>
  </section>

  <section class="body">
    <div *ngIf="editMode; else readModeTemplateRef">
      <div class="form-group mt-2">
        <textarea data-test="commentInput" [formControl]="commentFormController" class="form-control p-2"></textarea>
      </div>
    </div>

    <ng-template #readModeTemplateRef>
      <div class="read-comment">
        <p data-test="commentText">{{commentFormController.value}}</p>
      </div>
    </ng-template>
  </section>
</main>